import {combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import * as asyncInitialState from 'redux-async-initial-state';
import main from "./main";
import guide from './guide';

export default history => combineReducers({
    router: connectRouter(history),
    main,
    guide,
    asyncInitialState: asyncInitialState.innerReducer,
});
